<div
    [class]="'agpr-aiDisclaimer ' + containerClass"
>
    <div class="agpr-aiDisclaimer-header">
        <h2 class="agpr-aiDisclaimer-title">
            {{'Common.dialog.aiHelper.disclaimer.title' | localize}}
        </h2>
        <agpr-button
            class="agpr-aiDisclaimer-toggler"
            [attr.aria-label]="disclaimerCollapsed ? ('Core.expand' | localize) : ('Core.collapse' | localize)"
            [style]="buttonEnum.icon"
            [icon]="disclaimerCollapsed ? 'fa-solid fa-angle-up' : 'fa-solid fa-angle-down'"
            (click)="setDisclaimerToggle()"
        >
        </agpr-button>
    </div>

    <agpr-scroll-panel
        #scrollPanel
        [@panelContent]="disclaimerCollapsed ? 'hidden' : 'visible'"
        (@panelContent.done)="onToggleDone($event)"
    >
        <div class="agpr-aiDisclaimer-content">
            <span [innerHTML]="'Common.dialog.aiHelper.disclaimer' | localize">
            </span>
            <a
                class="agpr-aiDisclaimer-content-link"
                target="_blank"
                href="https://www.agilitypr.com/wp-content/uploads/2023/01/2023-01-PR-CoPilot-Terms.pdf"
            >
                {{'Common.dialog.aiHelper.disclaimer.termLink' | localize}}
            </a>
        </div>
    </agpr-scroll-panel>

    <div class="agpr-aiDisclaimer-actions">
        <agpr-checkbox
            class="agpr-aiDisclaimer-actionsLeft"
            [label]="'Common.dialog.aiHelper.acknowledgeDisclaimer'"
            [value]="agreedDisclaimer"
            (onChange)="changeDisclaimer($event)"
        ></agpr-checkbox>
        <div class="agpr-aiDisclaimer-actionsRight" >
            @if (confirmButton) {
                <agpr-button
                    [id]="'distribution_create_draft_apply'"
                    label="Core.button.apply"
                    class="agpr-aiDisclaimer-button"
                    [disabled]="!agreedDisclaimer || disabled"
                    (click)="applyClicked()"
                    [style]="buttonEnum.primary"
                ></agpr-button>
            }
        </div>
    </div>
</div>
